import axios from 'axios';
import { stringify } from 'qs';
export const DEFAULT_TIMEOUT = 10000;
export const getParamSerializerForAxiosVersion1or0 = () => {
    const serializer = (params) => stringify(params, { arrayFormat: 'repeat' });
    return axios.VERSION.startsWith('0.') ? serializer : { serialize: serializer };
};
const API = (apiUrl, config) => {
    return axios.create({
        baseURL: apiUrl || '/api',
        timeout: DEFAULT_TIMEOUT,
        paramsSerializer: getParamSerializerForAxiosVersion1or0(),
        withCredentials: false,
        ...config,
    });
};
export default API;
